// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__oayhA","emails":"CreateEditClinics_emails__1OMWU","emailTagLabel":"CreateEditClinics_emailTagLabel__3L5Zw"};